<template>
  <v-container grid-list-md>
    <v-form ref="form" lazy-validation class="settings" v-model="valid">
      <v-layout class="wrap">
        <v-flex xs12>
          <view-title />
        </v-flex>
        <v-flex xs12>
          <notification-name :notification.sync="notification"> </notification-name>
        </v-flex>
        <v-flex xs12> </v-flex>
        <v-flex xs12>
          <notification-scheduler :notification.sync="notification"></notification-scheduler>
        </v-flex>
        <v-flex xs12 style="padding-bottom: 50px"> </v-flex>
        <v-flex xs12>
          <save-footer
            v-show="isModified"
            :cancelAction="cancel"
            :saveLabel="isNewNotif ? 'Create New Notification' : 'Save Changes'"
            :saveAction="save"
          />
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import DateTime from 'luxon/src/datetime.js';
import { mapMutations, mapActions } from 'vuex';
import notificationName from './components/notification-name';
import notificationScheduler from './components/notif-scheduler';

export default {
  components: {
    notificationName,
    notificationScheduler,
  },
  data: () => ({
    valid: true,
    notification: {
      title: '',
      description: '',
      date_created: '',
      time_created: '',
      scheduled_release_date: '',
      scheduled_release_time: '',
    },
    backupNotification: null,
  }),
  methods: {
    ...mapActions('notifications', ['fetchNotifications']),
    ...mapMutations('notifications', ['setNotifications']),
    cancel() {
      // restore backupss
      this.$set(this, 'notification', cloneDeep(this.backupNotification));
      this.$refs.form.resetValidation();
      this.$toast('All your changes have been reset');
    },
    async save() {
      const isValidForm = this.$refs.form.validate();
      if (!this.valid || !isValidForm) {
        this.$toast('The form is not yet complete, please fix before saving');
        return;
      }
      let error;
      try {
        // Commented out code is for future notif scheduling (CM-2781 Epic)
        const timestamp = new Date(
          `${this.notification.scheduled_release_date}T${this.notification.scheduled_release_time}`,
        );
        const now = new Date().toISOString();
        const notif_payload = {
          text: this.notification.description,
          title: this.notification.title,
          realm: 'cdl',
          target: 'admin_panel',
          date_modified: timestamp.toISOString(),
        };
        if (timestamp !== 'Invalid Date' && now < timestamp.toISOString()) {
          notif_payload.release_date = timestamp.toISOString();
        }
        const res = await this.api.patch(
          `/notification/${this.$route.params.notification_id}`,
          notif_payload,
        );
        const index = this.$store.state.notifications.notifications.findIndex(
          (item) => item.id === this.$route.params.notification_id,
        );
        const notif_clone = cloneDeep(this.$store.state.notifications.notifications);
        notif_clone[index] = res.data;
        this.$store.commit('notifications/setNotifications', notif_clone);
      } catch (err) {
        error = err;
      }
      if (error) {
        console.error(error);
        this.$toast.error(`Unable to save notification.`);
        return;
      }
      this.$toast('Saved successfully');
      this.$router.push({
        name: 'notification-manager',
      });
    },
    selected_notification() {
      const vuex_notif = this.$store.state.notifications.notifications.find(
        (notif) => notif.id === this.$route.params.notification_id,
      );
      if (!vuex_notif) {
        return;
      }
      const parsed_iso = vuex_notif.date_modified.split('T');
      const parsed_date = DateTime.fromISO(vuex_notif.date_modified, { zone: 'utc' });
      const parsed_release_date = DateTime.fromISO(vuex_notif.release_date);
      const formattedDate = DateTime.fromISO(vuex_notif.release_date)
        .toString()
        .split('T')[0];
      const notif_to_edit = {
        title: vuex_notif.title || 'Ap3 Notification ',
        id: vuex_notif.id,
        description: vuex_notif.text,
        date_created: parsed_iso[0],
        time_created: parsed_date.toLocaleString(DateTime.TIME_24_SIMPLE),
        scheduled_release_date: formattedDate,
        scheduled_release_time: this.fixTime(
          parsed_release_date.toLocaleString(DateTime.TIME_24_SIMPLE),
        ),
      };
      this.notification = notif_to_edit;
    },
    fixTime(time) {
      // this library will render 12:24 am as 24:45 am, here is the fix
      const split_time = time.split(':');
      if (split_time[0].includes('24')) {
        split_time[0] = '00';
        return split_time.join(':');
      }
      return time;
    },
  },
  computed: {
    isNewNotif() {
      return !this.$route.params.notification_id;
    },
    isModified() {
      return !isEqual(this.notification, this.backupNotification);
    },
    today() {
      return DateTime.local().toISODate();
    },
  },
  async created() {
    this.selected_notification();
    this.$set(this, 'backupNotification', cloneDeep(this.notification));
    this.$store.commit('adminPanel/setViewTitle', {
      depth: 1,
      title: 'Edit In App Notification',
      to: { name: 'notification-edit' },
    });
  },
};
</script>
